import sensors from 'sa-sdk-javascript';
import Exposure from 'sa-sdk-javascript/dist/web/plugin/exposure/index.es6';
import pConfig from 'pConfig';
import utils from 'utils';
import { store } from 'store';
const exposure = sensors.use(Exposure, {
  area_rate: 0.5,
  stay_duration: 2,
  repeated: true
});
sensors.init({
  server_url: pConfig.SA_SERVER_URL,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  show_log: /console=true/.test(window.location.href),
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect'
  }
});
const redux = JSON.parse(
  localStorage.getItem('persist:redux') || JSON.stringify('')
);
const { token } = JSON.parse(redux?.user || '{}') || {
  token: '',
  userInfo: null
};
function getInitToken() {
  // TODO: 暂时解决方法
  const queryToken = utils.getQueryString('token');
  if (queryToken === '(null)') {
    return;
  }
  if (queryToken) {
    return queryToken;
  }
  return token;
}
async function init() {
  const token = getInitToken();
  if (!token) {
    return;
  }
  const json = await fetch(
    `${pConfig.API_HOST}app-interface/v1/user/user_info?token=${token}`
  );
  if (json.ok) {
    const res = await json.json();
    if (res.code) {
      return;
    }
    store.dispatch({
      type: 'user/updateUser',
      payload: res.data
    });
    const { user_key, uid } = res?.data?.user || { user_key: '', uid: '' };
    sensors.login(uid);
    sensors.registerPage({
      user_key
    });
  } else {
    return;
  }
}
init();
export { exposure };
export default sensors;
